import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/common/Loader';

const PrivateRoute = ({ children, roles }) => {
  const { isAuthenticated, loading, user, userType } = useAuth();
  const location = useLocation();

  // DEBUG: Log PrivateRoute state
  console.log('🔒 PrivateRoute check:', {
    path: location.pathname,
    isAuthenticated,
    loading,
    user,
    userType,
    requiredRoles: roles
  });

  // Show loader while checking auth
  if (loading) {
    console.log('🔒 PrivateRoute: Still loading auth...');
    return <Loader fullScreen />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('🔒 PrivateRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If roles are specified, check user role
  // Check both activeRoleId and roleId for compatibility
  if (roles && roles.length > 0) {
    const userRole = user?.activeRoleId || user?.roleId;
    console.log('🔒 PrivateRoute: Checking role. userRole:', userRole, 'requiredRoles:', roles);
    
    // If user has a role and it's not in the allowed roles, redirect
    // But if user has NO role (null/undefined), allow access to prevent loops
    if (userRole && !roles.includes(userRole)) {
      console.log('🔒 PrivateRoute: Role mismatch, redirecting...');
      // Redirect to appropriate dashboard based on role
      // Role ID mapping: 1=Super Admin, 2=Admin, 3=Participant, 4=Individual
      const roleRoutes = {
        1: '/admin-dashboard',
        2: '/admin-dashboard',
        3: '/participant-dashboard',
        4: '/individual-dashboard',
        5: '/org-owner-dashboard',
        6: '/team-captain-dashboard',
        7: '/volunteer-dashboard',
      };
      const redirectTo = roleRoutes[userRole];
      
      // Only redirect if we have a valid destination that's different from current path
      if (redirectTo && redirectTo !== location.pathname) {
        console.log('🔒 PrivateRoute: Redirecting to:', redirectTo);
        return <Navigate to={redirectTo} replace />;
      }
    }
  }

  console.log('🔒 PrivateRoute: Access granted');
  return children;
};

export default PrivateRoute;
